import React from "react";
import * as moment from "moment";

const InvoiceDateFormField = ({ render, value, onChange }) => {
  if (render === "hide") {
    return null;
  }
  if (render === "show")
    return (
      <>
        <label>Invoice Date:</label>
        <input
          className="form-control form-control-sm"
          name="invoiceDate"
          onChange={onChange}
          type="date"
          value={
            value === null || value === "0001-01-01T00:00:00"
              ? ""
              : moment(value).format("YYYY-MM-DD")
          }
        />
      </>
    );
  else {
    return null;
  }
};

export default InvoiceDateFormField;
